import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { ServiceLocator } from './core/auth/services';
import { AppStateService } from './core/auth/services/app-state.service';
import { DataLayerService } from './core/auth/services/data-layer.service';
import { FooterComponent } from './core/dashboard/components/footer/footer.component';
import { NavbarComponent } from './core/dashboard/components/navbar/navbar.component';
import { User } from './shared/models';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare const CanvasJS: any;

@Component({
	selector: 'engagement-root',
	standalone: true,
	imports: [RouterOutlet, FooterComponent, NavbarComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
	public user: User;
	public appReady: boolean;
	private destroy$ = new Subject<void>();

	constructor(
		injector: Injector,
		private appStateService: AppStateService,
		private dataLayerService: DataLayerService,
		private router: Router,
	) {
		ServiceLocator.injector = injector;
		const origin = window.location.origin;
		environment.apiUrl = (environment.apiUrls as { [key: string]: string })[origin] || environment.apiUrl;

		CanvasJS.addColorSet('pieChartColors', ['#D5DFEC', '#214A86', '#1E91D6']);
	}

	ngOnInit(): void {
		this.appStateService.onReady.subscribe((ready: { app: boolean }) => {
			this.appReady = ready.app;
		});

		// Subscribe to router events to track page views
		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				takeUntil(this.destroy$),
			)
			.subscribe((event: NavigationEnd) => {
				this.dataLayerService.pushToDataLayer('page_view', {
					page_path: event.urlAfterRedirects,
					page_title: document.title, // Or dynamically set based on route
				});
			});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
